import { FETCH_ARTWORK_FAMILIES } from '../actions/types'

export default (state = [], action) => {
  switch (action.type) {
    case FETCH_ARTWORK_FAMILIES:
      return action.payload
    default:
      return state
  }
}
